import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import { configData } from "../config";
import 'react-quill/dist/quill.snow.css';
import './classes/ReferralAdminConfig.css';
import { Pointer } from 'highcharts';

const ReferralAdminConfig = ({user,coupon,showcustomcoupon,orgcoupon,userLoggedInRoles}) => {
  
const [formData, setFormData] = useState({
  referrer: { addreferrer_email: '', referee_first_name: '', referee_last_name: '',drupal_uid:user.drupal_uid,uid:user.uid },
  bonus: { referer_bonus_amount: '0' },
  apps: { sales_person: '0' },
  coupon: { coupon_discount_id: '250' },
  referrerBonus: { bonus_amount: '100' },
  pageContent: { content: '' },
});
  
  const[success,setSuccess] = useState({});
  const app_url = configData.APP_URL;
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [referralList, setReferralList] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const[SalesPerson, setSalespersonList] = useState([]);
  const[Coupon, setRefereeDiscountList] = useState([]);
  const{details, setDetails} = useState({});
const [errors, setErrors] = useState({});
  // const [firstName, lastName] = user.name.split(" ");
  
//   const SalesPerson = [
// 	{value:"0" , label:"Draft"},
// 	{value:"1446" , label:"Adam Klimek"},
// 	{value:"404931" , label:"Chuck Patterson"},
// 	{value:"606669" , label:"Dewayne Penney"},
// 	{value:"1071" , label:"Jeff Brodie"},
// 	{value:"404930" , label:"Jon Laforce"},
// 	{value:"2792" , label:"Maikel Tsuji"},
// 	{value:"803138" , label:"Sara Landis"},
// 	{value:"2637" , label:"Student Services"}
// ];
 useEffect(() => {
const promises = [
    
    getsalespersonlist(),
   getrefereediscounts(),
   getadminconfigdetails()
  ];

 
  Promise.all(promises)
    .then(() => {
      //setIsLoading(false);
    })
    .catch(error => {
      console.error(error);
      // Handle error
    });
    
  },[]);
async function getsalespersonlist() {
    
        try {
      
            const response = await fetch(
                app_url+'user/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }
  async function getrefereediscounts() {
    
        try {
      
            const response = await fetch(
                app_url+'referral/getreferreediscounts',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setRefereeDiscountList(responsedata.data.result);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }
  async function getadminconfigdetails() {
    
        try {
      
            const response = await fetch(
                app_url+'referral/getadminconfigdetails?uid='+user.uid+'&coupon='+coupon,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               // setDetails(responsedata.data.result);
               setReferralList(responsedata.data.apps);
              setFormData({ ...formData, ...responsedata.data.details });
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }
const getSalesPersonLabel = (value) => {
  const found = SalesPerson.find((sp) => sp.uid === value);
  return found ? found.label : value; // fallback to value
};
//   const Coupon = [
// 	{value:"245" , label:"discount_referee_discount_50"},
// 	{value:"250" , label:"discount_discount_referee_100"},
// 	{value:"251" , label:"discount_discount_referee_25"},
// 	{value:"252" , label:"discount_discount_referee_75"},
// 	{value:"393" , label:"discount_test_today"},
// 	{value:"476" , label:"discount_testing_ref28"},
// 	{value:"483" , label:"discount_testingrefff28"}
// ];
  
const handleChange = (formKey, e) => {
  const { name, value } = e.target;
  setFormData({
    ...formData,
    [formKey]: {
      ...formData[formKey],
      [name]: value
    }
  });
};

const handleQuillChange = (value) => {
  setFormData(prev => ({
    ...prev,
    pageContent: { content: value }
  }));
};


const isValidEmail = (email) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};


const handleSubmit = async (formKey, e) => {
  e.preventDefault(); // prevent page reload
    if (formKey === "referrer") {
    const email = formData.referrer.addreferrer_email;

    // Email validation
    if (!isValidEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }
  }
    //  Integer-only validation for bonus (commas allowed in UI)
  if (formKey === "bonus") {
    const bonusAmount = formData.bonus.referer_bonus_amount || "";

    // remove commas before validation
    const normalizedAmount = bonusAmount.replace(/,/g, "");

    // validate integer
    if (!/^\d+$/.test(normalizedAmount)) {
      alert("Bonus amount must be a whole number.");
      return;
    }

    // overwrite value so backend gets integer only
    formData.bonus.referer_bonus_amount = normalizedAmount;
  }
  

  console.log(`Submitting form: ${formKey}`);
  console.log(formData[formKey]);
  console.log(formData.pageContent.content);


  // Example: if it's the apps form, you might want to add a new record
  if (formKey === 'apps') {
    const newRecord = {
      id: Date.now(),
      email: user.email,
      sales_person: formData.apps.sales_person
    };
    setReferralList([...referralList, newRecord]);
  }
 const response = await fetch(app_url+'referral/addreferraldetails', {
      method: 'POST',
      body: JSON.stringify({
        formData: formData, 
        drupal_uid: user.drupal_uid,
        uid:user.uid,
        formKey:formKey
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
       if(data.data.msg === "Success") {
         setSuccess(data.data.result);
          setErrors('');
          getadminconfigdetails();
          window.scrollTo(0, 0);
       }
       else if(data.data.msg === "Error") {
         setSuccess('');
        setErrors(data.data.result);
        window.scrollTo(0, 0);
       }
  // Reset form if needed
  // setFormData({ ...formData, [formKey]: {} });
};
    // Delete handler
  // const deleteRecord = (id) => {
  //   alert('Are you sure you want to remove?');
  //   setReferralList(referralList.filter((item) => item.id !== id));

   
  // };
  const deleteRecord = async (id) => {
  const confirmDelete = window.confirm('Are you sure you want to remove?');
  if (!confirmDelete) return;

  try {
    const response = await fetch(
      app_url + 'referral/removesalesperson',
      {
        method: 'POST',
        body: JSON.stringify({
          id: id,
          uid: user.uid,
          drupal_uid: user.drupal_uid,
          coupon: coupon
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const data = await response.json();

    if (data.data.msg === 'Success') {
      setReferralList(prev =>
        prev.filter(item => item.id !== id)
      );
    } else {
     // alert(data.data.result || 'Unable to delete record');
    }

  } catch (error) {
    console.error('Delete failed:', error);
   // alert('Something went wrong while deleting.');
  }
};


  return (    
    
        <div id="Landingpage" className="tabcontent admin-config" style={{"lineHeight": "2em"}}>
  {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`,padding:"9px 42px"}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
       {success.length > 0 && (
          <>
           {success.map((item, index) => {
             return <>
            <br/><div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: item}}></span>
          </div></>
          
        })}  
          </>
        )}
         <div>
           <a href="#" onClick={(e) => { e.preventDefault(); setOpen1(!open1); }}>
             Add Referrals
           </a>
   
      {open1 && (
        <div className="add_referrals">
          <fieldset className="groupbox-border">
            <legend className="groupbox-border">Add Referrals</legend>            
	            * Please use a comma if you have to go to add multiple entries. Do not use spaces to separate entries.<br /><br />

            <form onSubmit={(e) => handleSubmit('referrer', e)}>
              Enter Email Address<br />
              <input type="text" name="addreferrer_email" style={{ width: 300, border: "1px solid #ccc", padding: 2 }} value={formData.referrer.addreferrer_email} onChange={(e) => handleChange('referrer', e)} /><br /><br />

              First Name<br />
              <input type="text" name="referee_first_name" style={{ width: 300, border: "1px solid #ccc", padding: 2 }} value={formData.referrer.referee_first_name}  onChange={(e) => handleChange('referrer', e)} /><br /><br />

              Last Name<br />
              <input type="text" name="referee_last_name" style={{ width: 300, border: "1px solid #ccc", padding: 2 }} value={formData.referrer.referee_last_name}  onChange={(e) => handleChange('referrer', e)}/><br /><br />

              <input type="submit" value="Add" className="form-submit" />
            </form>
          </fieldset>
        </div>
      )}
    </div>

    {/* Update Bonus Amount*/}
       {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) )) && 
         <div>
           <a href="#" onClick={(e) => { e.preventDefault(); setOpen2(!open2); }}>
             Edit Referral Wallet Balance Amount
           </a>
        {open2 && (
        <div class="add_referrals_bonus_amount" id="add_referrals_bonus_amount">
        <form onSubmit={(e) => handleSubmit('bonus', e)}>
        Bonus Amount<br/>

        <input type="text" name="referer_bonus_amount" style={{"width":"300px","border":"1px solid #ccc","padding": "2px"}} value={formData.bonus.referer_bonus_amount} onChange={(e) => handleChange('bonus', e)}/><br/><br/>
        <input type="submit" value="Add" className="form-submit"/> 
        </form>
        </div>
        )}
        </div>
}
        {/*apps distribution*/}
        <div>
             <a href="#" onClick={(e) => { e.preventDefault(); setOpen3(!open3); }}>
             Apps Distribution
           </a>
           {open3 && (
        <div className="add_referrals" id="config_referral_apps">

        <fieldset className="groupbox-border">
            <legend className="groupbox-border">Apps Distribution</legend> 
        
        <form onSubmit={(e) => handleSubmit('apps', e)}>
        <b>Salesperson:</b><br/>
         <select id="sales_person" 
        name="sales_person"
        value={formData.apps.sales_person}
        onChange={(e) => handleChange('apps', e)}
        ><option key="0" value="0">Draft</option>
              {SalesPerson.map((salesperson) => (
            <option key={salesperson.uid} value={salesperson.uid}>
            {salesperson.name}
            </option>
             ))}
        </select>
             &nbsp; &nbsp;
        <input type="submit" name="config_referral_apps" value="Submit"/>
        </form>
        <div className="page-view-myorder">
        <div className="panel panel-default">
          <div className="panel-body">
            <table className="table table-bordered table-striped">
            <tbody>
              <tr>
                <th>Referrer Email</th>
                <th>Referrer Sales Person</th>
                <th>Actions</th>
                </tr>
                
                  {referralList.map((item) => (
                  <tr key={item.id}>
                    <td>{item.email}</td>
                    {(!item.sales_person) ? (<td>Draft</td>) : (
                    <td>{getSalesPersonLabel(item.sales_person)}</td>)}
                  
                    <td>
                      <a
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteRecord(item.id)}
                        style={{"cursor":"Pointer"}}
                      >
                        Remove
                      </a>
                    </td>
                  </tr>
                ))}
                 
              </tbody>
            </table>

          </div>
        </div>
      </div>
   </fieldset>
        </div>
           )}
    </div>
    {/*edit refree coupon amount*/}
     <div>
           <a href="#" onClick={(e) => { e.preventDefault(); setOpen4(!open4); }}>
             Edit Referee Coupon Amount
           </a>
        {open4 && (
        <div id="edit_referral_coupon_amount">
        <fieldset className="groupbox-border">
            <legend className="groupbox-border">Edit Referee Coupon Amount</legend> 
        
        <form onSubmit={(e) => handleSubmit('coupon', e)}>
        
        <b>Coupon Amount:</b><br/>  
        <select id="coupon_discount_id" name="coupon_discount_id"
        value={formData.coupon.coupon_discount_id}
        onChange={(e) => handleChange('coupon', e)}>
            
          {Coupon.map((coupon) => (
            <option key={coupon.value} value={coupon.value}>
            {coupon.label}
            </option>
             ))}
        </select>
              &nbsp; &nbsp;
        <input type="submit" value="Submit" name="edit-coupon-amount"/>
        </form>
        </fieldset>
        </div>
        )}
        </div>
        {/*edit refree bonus amount*/}
        <div>
           <a href="#" onClick={(e) => { e.preventDefault(); setOpen5(!open5); }}>
             Edit Referrer Bonus Amount
           </a>
        {open5 && (
        <div id="edit_referral_discount">
        <fieldset class="groupbox-border">
            <legend class="groupbox-border">Edit Referrer Bonus Amount</legend> 
        <b>First Name:</b> {user.first_name}<br/><b>Last Name:</b> {user.last_name}<br/><b>E-Mail:</b> {user.email}<br/><br/>
        <form onSubmit={(e) => handleSubmit('referrerBonus', e)}> 
        <b>Bonus Amount:</b> <br/>  
        <input type="text" name="bonus_amount" id="bonus_amount" value={formData.referrerBonus.bonus_amount} onChange={(e) => handleChange('referrerBonus', e)}/> <br/><br/>
        <input type="submit" value="Submit" name="edit-discount-amount"/>
        </form>
        </fieldset>
        </div>
        )}
        </div>
    {/*edit referral page content*/}
        <div>
           <a href="#" onClick={(e) => { e.preventDefault(); setOpen6(!open6); }}>
            Edit Referral Page Content
           </a>
        {open6 && (
        <div id="edit_referral_page_content">
        <fieldset className="groupbox-border">
            <legend className="groupbox-border">Edit Referral Page Content</legend> 
        <form onSubmit={(e) => handleSubmit('pageContent', e)} >
         <div>
                <ReactQuill 
                value={formData.pageContent.content} 
                onChange={handleQuillChange}                
                style={{ backgroundColor:'#fff' }}
              />

            </div>
            <br/>
        <input type="submit" name="referral-form-submit" value="Submit"/>
        </form></fieldset>
        </div>
        )}
        </div>
        <a target="_blank" href="/admin/reports/refererrer_bonus">
            Referral Wallet Report
           </a><br/><br/>
           {showcustomcoupon == 1 && (
            <>This person customized their coupon code. Their original coupon code is {orgcoupon}</>
           )}
      <br/><br/>
        </div>
  );
};

export default ReferralAdminConfig;
